// extracted by mini-css-extract-plugin
export default {"ib":"IconButton_ib__ApANS","glyph":"IconButton_glyph__MMzrF","lg":"IconButton_lg__VnMLR"};